import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DocumentosCertiComponent } from './components/documentos-certi/documentos-certi.component';
import { ValidationMatriculaComponent } from './components/validation-matricula/validation-matricula.component';
import { SegemCertificacionComponent } from './components/segem-certificacion/segem-certificacion.component';

const routes: Routes = [
  // https://www.siseems-rvoes.sems.gob.mx/certificadodigital/certificadodigitalvalida/id_alumno/8eb65915-20f0-4ad7-9211-6165a1c1e981
  //  { path: 'validation/:matricula', component: ValidationMatriculaComponent },
  // { path: 'certificadodigital/certificadodigitalvalida/id_alumno/:folio', component: ValidationMatriculaComponent },
  // { path: 'certificadodigital/certificadodigitalvalida/id_alumno', component: ValidationMatriculaComponent },
  // { path: 'SIGED/documentos/folio/:folio', component: DocumentosCertiComponent },
  // { path: 'SIGED/documentos/folio', component: DocumentosCertiComponent },
   { path: 'certificado/consultarCertificado', component: SegemCertificacionComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
